import type { TFavoriteColors } from 'api/swagger';

export interface IColorsDropdownProps {
  cargoIds: number[];
  children: React.ReactNode;
  markedColors?: TFavoriteColors[];
}

export enum EAction {
  Add = 'add',
  Clear = 'clear',
}
